<script>
import {useCartStore} from "@js/store/CartStore.js";
import NumberFormatComponent from "@js/components/Formatter/NumberFormatComponent.vue";
import ProductFeature from "@js/components/Sections/Product/Components/ProductFeature.vue";
import {useCallbackFormsStore} from "@js/store/CallbackFormsStore.js";
import IconPhone from "@js/components/Icons/IconPhone.vue";
import CallbackErrorMessage from "@js/components/Sections/Callback/Components/CallbackErrorMessage.vue";
import {IMaskDirective} from 'vue-imask';
import IconUser from "@js/components/Icons/IconUser.vue";
import SpinnerIndicator from "@js/components/Sections/Statuses/SpinnerIndicator.vue";
import PrivacyPolicyAgreementLink from "@js/components/Sections/Contacts/Components/PrivacyPolicyAgreementLink.vue";

export default {
    name: "CartSummary",
    components: {
        PrivacyPolicyAgreementLink,
        SpinnerIndicator,
        IconUser,
        CallbackErrorMessage,
        IconPhone,
        ProductFeature,
        NumberFormatComponent
    },
    directives: {
        imask: IMaskDirective
    },
    data() {
        return {
            phoneMask: {
                mask: '+7 (000) 000-00-00',
            },
        }
    },
    methods: {
        updatePhone(newPhone) {
            this.callbackStore.forms.cart_form.data.phone = newPhone;
        },
    },
    setup() {
        const cartStore = useCartStore();
        const callbackStore = useCallbackFormsStore()

        return {cartStore, callbackStore};
    },
    computed: {
        totalWeight: function () {
            return this.cartStore.cart.reduce((total, item) => total + (parseFloat(item.weight) * item.quantity), 0)
        },
        totalQuantity: function () {
            return this.cartStore.cart.reduce((total, item) => total + item.quantity, 0)
        },
        totalPrice: function () {
            return this.cartStore.cart.reduce((total, item) => total + (parseFloat(item.price) * item.quantity), 0)
        },
    }
}
</script>

<template>
    <div
        class="space-y-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm sm:p-6">
        <div>
            <p class="text-xl font-bold text-gray-900 mb-2">
                Оформление заказа
            </p>
            <div class="space-y-4">
                <div class="space-y-2">
                    <div class="group relative flex items-center justify-between dotted_line font-medium text-sm">
                        <div class="bg-[#fcfcfc] z-1 pe-1 group-hover:text-indigo-600 transition">
                            Товары
                        </div>
                        <div class="bg-[#fcfcfc] z-1 ps-1 group-hover:text-indigo-600 transition">
                            <NumberFormatComponent :number="totalQuantity" append_text=" шт."/>
                        </div>
                    </div>
                    <div class="group relative flex items-center justify-between dotted_line font-medium text-sm">
                        <div class="bg-[#fcfcfc] z-1 pe-1 group-hover:text-indigo-600 transition">
                            Вес
                        </div>
                        <div class="bg-[#fcfcfc] z-1 ps-1 group-hover:text-indigo-600 transition">
                            <NumberFormatComponent :number="totalWeight.toFixed(2)" append_text=" т"/>
                        </div>
                    </div>
                    <div class="group relative flex items-center justify-between dotted_line font-medium text-sm">
                        <div class="bg-[#fcfcfc] z-1 pe-1 group-hover:text-indigo-600 transition">
                            Сумма
                        </div>
                        <div class="bg-[#fcfcfc] z-1 ps-1 group-hover:text-indigo-600 transition">
                            <NumberFormatComponent :number="totalPrice" append_text=" ₽"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        <div>
            <p class="text-xl font-bold text-gray-900">
                Ваши данные
            </p>
            <p class="text-xs font-semibold text-gray-500">
                Наш менеджер свяжется с Вами в течении 5 минут
            </p>
            <div class="flex flex-col gap-5 md:gap-8 w-full mb-5 mt-5">
                <div>
                    <div class="relative w-full lg:w-auto">
                        <div
                            class="absolute inset-y-0 start-0 top-0 flex items-center ps-3.5 pointer-events-none">
                            <IconPhone class="w-6 h-6 text-gray-500"/>
                        </div>
                        <input type="tel"
                               @keyup="updatePhone($event.target.value)"
                               :value="callbackStore.forms.cart_form.data.phone"
                               v-imask="phoneMask"
                               id="ctf_phone" aria-describedby="helper-text-explanation"
                               class="bg-transparent border border-gray-300 text-gray-900 text-md rounded-lg focus:divide-indigo-600 focus:border-indigo-600 block w-full ps-10 px-4 py-2.5"
                               :class="[callbackStore.forms.cart_form.errors && callbackStore.forms.cart_form.errors['phone'] ? 'border-red-500' : '']"
                               placeholder="+7 (___) ___-__-__" required/>
                    </div>
                    <CallbackErrorMessage :error="callbackStore.forms.cart_form.errors"
                                          :error-msg="'phone'"/>
                </div>
                <div>
                    <div class="relative w-full lg:w-auto">
                        <div
                            class="absolute inset-y-0 start-0 top-0 flex items-center ps-3.5 pointer-events-none">
                            <IconUser class="w-6 h-6 text-gray-500"/>
                        </div>
                        <input v-model="callbackStore.forms.cart_form.data.full_name"
                               type="text" id="ctf_full_name"
                               aria-describedby="helper-text-explanation"
                               class="bg-transparent border border-gray-300 text-gray-900 text-md rounded-lg focus:divide-indigo-600 focus:border-indigo-600 block w-full ps-10 px-4 py-2.5"
                               :class="[callbackStore.forms.cart_form.errors && callbackStore.forms.cart_form.errors['full_name'] ? 'border-red-500' : '']"
                               pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                               placeholder="Как к вам обращаться?" required/>
                    </div>
                    <CallbackErrorMessage :error="callbackStore.forms.cart_form.errors"
                                          :error-msg="'full_name'"/>
                </div>
                <div class="relative w-full lg:w-auto flex justify-center">
                    <button @click.prevent="callbackStore.sendCartForm" type="button"
                            class="w-full flex justify-center items-center  text-white hover:text-indigo-600 border-2 border-indigo-600 bg-indigo-600 hover:bg-transparent font-medium rounded-lg text-sm px-10 py-2.5 focus:outline-none transition">
                        <span class="text-base">
                            Оформить заявку
                        </span>
                        <SpinnerIndicator v-if="callbackStore.forms.cart_form.sending"
                                          class="w-6 h-6 ms-2"/>
                    </button>
                </div>
            </div>
            <div class="flex items-center ">
                <PrivacyPolicyAgreementLink class="text-center"/>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.z-1 {
    z-index: 1;
}

.dotted_line:before {
    content: '';
    width: 100%;
    position: absolute;
    bottom: 5px;
    left: 0;
    border-bottom: 1px dotted #515151;
    transition: .25s;
}

.dotted_line:hover:before {
    border-bottom: 1px dotted var(--main-color);
}
</style>
